const resendMallIntegration = async ({ data, api }) => {
  return await api(`mallIntegration/resend/${data.id}`, { body: data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default resendMallIntegration;